<button (click)="onClicked($event)"
        [disabled]="disabled() || isLoading()"
        class="ai-button relative inline-flex h-10 cursor-pointer items-center gap-2 overflow-hidden rounded-md px-4 text-sm font-medium text-white ring-1 ring-inset ring-white/25 transition-[filter] duration-200 disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-300"
        type="button">
  <span aria-hidden="true" class="ai-button__shine pointer-events-none absolute inset-0"></span>
  <span [class]="isLoading() ? 'pi pi-spin pi-spinner' : primeIcon()"
        aria-hidden="true"
        class="ai-button__icon relative text-sm"></span>
  @if (label(); as label) {
    <span class="relative">{{ label }}</span>
  }
</button>
